import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LivePriceProvider } from "@/context/LivePriceContext";
import TopNav from "@/components/TopNav";
import LivePriceTicker from "@/components/LivePriceTicker";
import AuthModal from "@/components/AuthModal";
import HomePage from "@/pages/HomePage";
import ValidatorsPage from "@/pages/ValidatorsPage";
import TokenomicsPage from "@/pages/TokenomicsPage";
import MinerTerminalPage from "@/pages/MinerTerminalPage";
import ReferralsPage from "@/pages/ReferralsPage";
import { WalletDashboardPage, WalletDepositPage, WalletSendPage, WalletReceivePage, WalletWithdrawPage } from "@/pages/WalletPages";
import SwapPage from "@/pages/SwapPage";

function Shell() {
    const [authOpen, setAuthOpen] = useState(false);
    const openAuth = () => setAuthOpen(true);

    return (
        <>
            <div className="relative">
                <TopNav onOpenAuth={openAuth} />
                <LivePriceTicker />
                <Routes>
                    <Route path="/" element={<HomePage onConnect={openAuth} />} />
                    <Route path="/miner" element={<MinerTerminalPage onConnect={openAuth} />} />
                    <Route path="/referrals" element={<ReferralsPage onConnect={openAuth} />} />
                    <Route path="/wallet" element={<WalletDashboardPage />} />
                    <Route path="/wallet/deposit" element={<WalletDepositPage />} />
                    <Route path="/wallet/withdraw" element={<WalletWithdrawPage />} />
                    <Route path="/wallet/send" element={<WalletSendPage />} />
                    <Route path="/wallet/receive" element={<WalletReceivePage />} />
                    <Route path="/validators" element={<ValidatorsPage />} />
                    <Route path="/swap" element={<SwapPage onConnect={openAuth} />} />
                    <Route path="/tokenomics" element={<TokenomicsPage />} />
                    <Route path="*" element={<HomePage onConnect={openAuth} />} />
                </Routes>
            </div>
            <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
            <Toaster
                theme="light"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#FFFFFF",
                        border: "1px solid #E2E8F2",
                        color: "#0A0E1A",
                        fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
                        boxShadow: "0 12px 24px -8px rgba(10,14,26,0.10), 0 4px 8px -4px rgba(10,14,26,0.06)",
                    },
                }}
            />
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ThemeProvider>
                    <AuthProvider>
                        <LivePriceProvider>
                            <Shell />
                        </LivePriceProvider>
                    </AuthProvider>
                </ThemeProvider>
            </BrowserRouter>
        </div>
    );
}
